export const ADD_ROW = 'app/EditSessionPage/Grid/ADD_ROW';
export const ADD_COLUMN = 'app/EditSessionPage/Grid/ADD_COLUMN';
export const UPDATE_ROW = 'app/EditSessionPage/Grid/UPDATE_ROW';
export const UPDATE_COLUMN = 'app/EditSessionPage/Grid/UPDATE_COLUMN';
export const DELETE_ROW = 'app/EditSessionPage/Grid/DELETE_ROW';
export const DELETE_COLUMN = 'app/EditSessionPage/Grid/DELETE_COLUMN';
export const REORDER_ROWS = 'app/EditSessionPage/Grid/REORDER_ROWS';
export const REORDER_COLUMNS = 'app/EditSessionPage/Grid/REORDER_COLUMNS';
